import { ja, enUS, zhCN, fr, es, de, ptBR, ru, Locale } from 'date-fns/locale';
import { format } from 'date-fns';

const localeMap: Record<string, Locale> = {
  ja,
  en: enUS,
  'zh-CN': zhCN,
  fr,
  es,
  de,
  pt: ptBR,
  ru,
};

/**
 * i18n language code に対応する date-fns Locale を返す
 */
export function getDateFnsLocale(language: string): Locale {
  return localeMap[language] ?? enUS;
}

/** サンプル管理系の日時表示パターン（日本語は /、他は -） */
export function sampleDateTimePattern(language: string): string {
  return language === 'ja' ? 'yyyy/MM/dd HH:mm' : 'yyyy-MM-dd HH:mm';
}

/** 一覧の作製日など日付のみ */
export function sampleDatePattern(language: string): string {
  return language === 'ja' ? 'yyyy/MM/dd' : 'yyyy-MM-dd';
}

export function formatSampleDateTime(
  value: Date | string | number,
  language: string
): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return format(date, sampleDateTimePattern(language), {
    locale: getDateFnsLocale(language),
  });
}

export function formatSampleDate(
  value: Date | string | number,
  language: string
): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return format(date, sampleDatePattern(language), {
    locale: getDateFnsLocale(language),
  });
}

/** 詳細画面向けのやや長い日時（日本語は「年月日」） */
export function formatSampleDateTimeLong(
  value: Date | string | number,
  language: string
): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  const pattern = language === 'ja' ? 'yyyy年MM月dd日 HH:mm' : 'yyyy-MM-dd HH:mm';
  return format(date, pattern, { locale: getDateFnsLocale(language) });
}

/** 詳細画面向けのやや長い日付のみ（廃棄日など） */
export function formatSampleDateLong(
  value: Date | string | number,
  language: string
): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  const pattern = language === 'ja' ? 'yyyy年MM月dd日' : 'yyyy-MM-dd';
  return format(date, pattern, { locale: getDateFnsLocale(language) });
}
